import { useGetOne } from "./useGetOne";
import { SpotContractDeal } from "../api/spot_contract_deal";

export const useSpotContractDeal = (id: number | undefined) => useGetOne<SpotContractDeal>("spot_contract_deals", id);
